/**
 * Created by pc on 2019/3/20.
 */
import { get, post, remove, patch } from '../../http'
import Page from '@/global/util/Page';
const SUB_ACCOUNT_USER_LIST = 'SUB_ACCOUNT_USER_LIST' // 子账号管理列表
const SUB_ACCOUNT_USER_TYPE = 'SUB_ACCOUNT_USER_TYPE' // 创建账户类型
const SUB_ACCOUNT_USER_TEMPLATE_MENU = 'SUB_ACCOUNT_USER_TEMPLATE_MENU' // 权限管理筛选项
const SUB_ACCOUNT_ROLE_TYPE = 'SUB_ACCOUNT_ROLE_TYPE' // 账户类型下拉菜单

const state = {
  subAccount: {
    page: new Page(),
    userTypeMenu: [],
    curUserType: '',
    roleTypeMenu: [],
    curRoleType: '',
    userTemplateMenu: [],
    curUserTemplate: ''
  }
}

const getters = {
  subAccount: state => state.subAccount
}

const actions = {
  async userItem ({ state, commit }, { data }) { // 获取通用配置项
    let response = await get('/interface/etcd/item/' + data)
    return response
  },
  async reviewUser ({ state, commit }, { id, data }) { // 审核用户
    let response = await post('/general/user/audit/' + id, data)
    return response
  },
  async getUserTypeMenu ({ state, commit }, { params, isAll } = {}) {
    await get('/general/user/user_type', params).then(res => {
      if (res.code === 1) {
        commit(SUB_ACCOUNT_USER_TYPE, { result: res.data, isAll })
      }
    })
  },
  async getRoleTypeMenu ({ state, commit }, { params, isAll } = {}) {
    await get('/general/user/role_type', params).then(res => {
      if (res.code === 1) {
        commit(SUB_ACCOUNT_ROLE_TYPE, { result: res.data, isAll })
      }
    })
  },
  async getUserTemplateMenu ({ state, commit }, { params, isAll } = {}) {
    await get('/general/user/template', params).then(res => {
      if (res.code === 1) {
        commit(SUB_ACCOUNT_USER_TEMPLATE_MENU, { result: res.data, isAll })
      }
    })
  },
  async addUser ({ state, commit }, { data }) { // 新增用户
    let response = await post('/general/user', data)
    return response
  },
  async deleteUser ({ state, commit }, { data }) { // 删除用户
    let response = await remove('/general/user/' + data.id)
    return response
  },
  async updateUser ({ state, commit }, { id, data }) { // 更新用户
    let response = await patch('/general/user/' + id, data)
    return response
  },
  async userList ({ state, commit }, { data }) { // 用户列表 / 获取用户信息
    let response
    if (data.id) {
      response = await get('/general/user/' + data.id)
      return response
    } else {
      get('/general/user/', data).then(res => {
        if (res.code === 1) {
          commit(SUB_ACCOUNT_USER_LIST, { data: res.data })
        }
      })
    }
  }
}

const mutations = {
  [SUB_ACCOUNT_USER_TYPE] (state, result) {
    let arr = {};
    arr.name = '全部';
    arr.value = '0';
    state.subAccount.userTypeMenu = result.result;
    if (result.isAll) {
      state.subAccount.userTypeMenu.unshift(arr);
    }
    state.subAccount.curUserType = result.result.length ? result.result[0].value : ''
  },
  [SUB_ACCOUNT_ROLE_TYPE] (state, result) {
    let arr = {};
    arr.name = '全部';
    arr.value = '0';
    state.subAccount.roleTypeMenu = result.result;
    if (result.isAll) {
      state.subAccount.roleTypeMenu.unshift(arr);
    }
    state.subAccount.curRoleType = result.result.length ? result.result[0].value : ''
  },
  [SUB_ACCOUNT_USER_TEMPLATE_MENU] (state, result) {
    let arr = {};
    arr.name = '全部';
    arr.value = '0';
    state.subAccount.userTemplateMenu = result.result;
    if (result.isAll) {
      state.subAccount.userTemplateMenu.unshift(arr);
    }
    state.subAccount.curUserTemplate = result.result.length ? result.result[0].value : ''
  },
  [SUB_ACCOUNT_USER_LIST] (state, data) {
    state.subAccount.page.setPageData({
      header: data.data.header,
      data: data.data.list,
      total: data.data.count
    },
    false
    )
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
